var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgText(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19_1620)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.948 2.25C7.04954 2.24997 6.3003 2.24995 5.70552 2.32991C5.07773 2.41432 4.51093 2.59999 4.05546 3.05546C3.59999 3.51093 3.41432 4.07773 3.32991 4.70552C3.24995 5.3003 3.24997 6.04951 3.25 6.94798V7.95C3.25 8.36422 3.58579 8.7 4 8.7C4.41422 8.7 4.75 8.36422 4.75 7.95V7C4.75 6.03599 4.7516 5.38843 4.81654 4.9054C4.87858 4.44393 4.9858 4.24644 5.11612 4.11612C5.24644 3.9858 5.44393 3.87858 5.9054 3.81654C6.38843 3.7516 7.03599 3.75 8 3.75H11.25V20.25H7C6.58579 20.25 6.25 20.5858 6.25 21C6.25 21.4142 6.58579 21.75 7 21.75H17C17.4142 21.75 17.75 21.4142 17.75 21C17.75 20.5858 17.4142 20.25 17 20.25H12.75V3.75H16C16.964 3.75 17.6116 3.7516 18.0946 3.81654C18.5561 3.87858 18.7536 3.9858 18.8839 4.11612C19.0142 4.24644 19.1214 4.44393 19.1835 4.9054C19.2484 5.38843 19.25 6.03599 19.25 7V7.95C19.25 8.36422 19.5858 8.7 20 8.7C20.4142 8.7 20.75 8.36422 20.75 7.95V6.94801C20.75 6.04953 20.7501 5.30031 20.6701 4.70552C20.5857 4.07773 20.4 3.51093 19.9445 3.05546C19.4891 2.59999 18.9223 2.41432 18.2945 2.32991C17.6997 2.24995 16.9505 2.24997 16.052 2.25H7.948Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_19_1620)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19_1620",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19_1620)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 4.2L0 19.8C0 22.1196 1.8804 24 4.2 24H19.8C22.1196 24 24 22.1196 24 19.8V4.2C24 1.88041 22.1196 0 19.8 0H4.2C1.8804 0 0 1.88041 0 4.2Z",
    fill: "#5D7AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.43 3.778H11.57C11.1177 3.778 10.751 4.14468 10.751 4.597V17.415C10.751 17.8673 11.1177 18.234 11.57 18.234H12.43C12.8823 18.234 13.249 17.8673 13.249 17.415V4.597C13.249 4.14468 12.8823 3.778 12.43 3.778Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.772 4.596V5.456C4.772 5.90832 5.13868 6.275 5.591 6.275L18.41 6.275C18.8623 6.275 19.229 5.90832 19.229 5.456V4.596C19.229 4.14368 18.8623 3.777 18.41 3.777L5.591 3.777C5.13868 3.777 4.772 4.14368 4.772 4.596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M16.895 20.877H7.105C6.93154 20.877 6.7652 20.8081 6.64255 20.6854C6.5199 20.5628 6.45099 20.3965 6.45099 20.223C6.45099 20.0495 6.5199 19.8832 6.64255 19.7606C6.7652 19.6379 6.93154 19.569 7.105 19.569H16.895C17.0684 19.569 17.2348 19.6379 17.3574 19.7606C17.4801 19.8832 17.549 20.0495 17.549 20.223C17.549 20.3965 17.4801 20.5628 17.3574 20.6854C17.2348 20.8081 17.0684 20.877 16.895 20.877Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19_1620"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_19_1620"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/text.3052890c75efd91da2dc9fe23928c839.svg";
export { ForwardRef as ReactComponent };